import { HelpCenterProvider } from '@/HelpCenter/ui/context'
import { createHelpCenterRepository } from '@/HelpCenter/infrastructure/ApiHelpCenterRepository'
import { MyTicketsList } from '@/HelpCenter/ui/organisms/MyTicketsList'

export const MyTicketsPage = (): JSX.Element => {
    return (
        <HelpCenterProvider repository={createHelpCenterRepository()}>
            <div className="page-wrapper" style={{ paddingTop: '102px', display: 'flex', flexDirection: 'column', minHeight: '100vh', paddingBottom: '12px' }}>
                <MyTicketsList />
            </div>
        </HelpCenterProvider>
    )
}
